import { bffCrmPersonBenefitDocuments } from '@fireflyhealth/api'
import type { BffCrmPersonBenefitDocumentsRetrieveResponse } from '@fireflyhealth/api'

import { keepPreviousData } from '@tanstack/react-query'
import { useQuery } from '~/shared/hooks/query'

const personBenefitDocumentsQueryKey = (
  personId: number,
  policyConfigurationId: number | undefined,
) =>
  bffCrmPersonBenefitDocuments.retrieveQueryKey(
    { person_id: personId },
    { policy_configuration_id: policyConfigurationId },
  )

/**
 * Fetches a member's plan documents, the plan years on offer, and the one they came from.
 * `policyConfigurationId` must be one of the returned `policy_configurations`; any other is a 400.
 */
export const useGetPersonBenefitDocuments = (variables: {
  personId: number | undefined
  policyConfigurationId?: number
}) => {
  const { personId, policyConfigurationId } = variables
  return useQuery<BffCrmPersonBenefitDocumentsRetrieveResponse>(
    personId != null
      ? personBenefitDocumentsQueryKey(personId, policyConfigurationId)
      : ['retrieveBffCrmPersonBenefitDocuments', {}],
    async () =>
      (
        await bffCrmPersonBenefitDocuments.retrieve(
          { person_id: Number(personId) },
          { params: { policy_configuration_id: policyConfigurationId } },
        )
      ).data,
    { enabled: personId != null, placeholderData: keepPreviousData },
    { error: 'Failed to fetch benefit documents' },
  )
}
